module.exports = __webpack_public_path__ + "img/tu-2_30.59128f84.jpg";